<template>
  <div class="cart-form-container">
    <div class="cart-form">
      <div class="cart-table">
        <div class="table-header">
          <div class="product-remove">&nbsp;</div>
          <mq-layout mq="tablet+">
            <div class="product-thumbnail">&nbsp;</div>
          </mq-layout>
          <div class="product-name">
            Produkt
          </div>
          <div class="product-customize">
            Endring
          </div>
          
          <div class="product-price">
            Pris
          </div>
          <div class="product-quantity">Antall</div>
          <div class="product-total">Subtotal</div>
        </div>

        <template v-for="item in selectedItems">
          <div class="cart-item" :key="item.index">
            <div class="product-remove">
              <a-icon type="close-circle" @click="handleBtnRemoveItem(item)" />
            </div>
            <div class="product">
              <div class="product-thumbnail">
                <img :src="item.imageUrl" alt="" />
              </div>
              <div>
                <div class="product-name">{{ item.itemName }}</div>
              </div>
            </div>
            <div class="customize-collapse">
              <a-collapse v-if="item.isCustomized">
                <template #expandIcon="props">
                  <a-icon
                    type="caret-right"
                    :rotate="props.isActive ? 90 : 0"
                  /> </template
                ><a-collapse-panel
                  class="panel-flex"
                  key="1"
                  header="Tilpasset Meny"
                >
                  <div v-for="o in item.options" style="display: flex; " :key="o.codeName">
                    <span>{{ o.description }}</span>:
                    <template v-for="op in o.options">
                      <span style="margin-left: 2px;"> {{ op.description }}</span>
                      <span style="margin-left: auto; color: #d44541;">+{{op.price}}kr</span>
                    </template>
                  </div>
                </a-collapse-panel></a-collapse>
            </div>

            <div class="product-price" v-if="item.discount > 0">
              <s>{{ item.itemPrice }}</s> / {{ getPrice(item) }}
            </div>
            <div class="product-price" v-else>
              {{ getPrice(item) }}
            </div>

            <div class="quantity-wrapper">
              <div class="product-quantity">
                <a-input-number
                  v-model="item.quantity"
                  :min="1"
                  :max="99"
                  @change="handleItemInCartQuantityChange"
                />
              </div>
            </div>

            <div class="product-total">
              {{ getPrice(item) * item.quantity }}
            </div>
          </div>
        </template>
      </div>
      <div class="action-button-container">
        <div class="total-price">
          <p class="total-sum">Total: {{ totalPrice }} kr (inkl. mva)</p>
          <p class="total-quantity">{{ totalItems }} varer i handlevognen</p>
        </div>

        <mq-layout mq="mobile">
          <button
            class="blk-button btn-pay"
            href="#"
            v-scroll-to="{ el: '#element' }"
          >
            Bekreft ordren / Gå videre
          </button></mq-layout
        >

        <div class="action-buttons">
          <div class="coupon-field">
            <input
              type="text"
              name="coupon_code"
              id="coupon_code"
              placeholder="Kupongkode"
              v-model="couponCode"
              @keyup.enter="handleBtnApplyCoupon"
            /><button class="blk-button" @click="handleBtnApplyCoupon">
              Bruk koden
            </button>
            <button
              v-if="discountCode"
              class="blk-button"
              @click="handleBtnRemoveCoupon"
            >
              Fjern koden
            </button>
            <p
              v-if="couponMessage"
              class="coupon-message"
              :class="{ 'coupon-message-error': couponError }"
            >
              {{ couponMessage }}
            </p>
          </div>

          <button
            class="blk-button btn-float-right"
            @click="handleBtnBackToMenu"
          >
            Tilbake til meny
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PriceCalculator from "../../commons/priceCalculator";
import DiscountCodes from "../../commons/discountCodes";
export default {
  components: {},
  data() {
    return {
      couponCode: "",
      couponMessage: "",
      couponError: false
    };
  },
  computed: {
    ...mapState({
      selectedItems: state => state.cart.selectedItems,
      discountCode: state => state.cart.discountCode
    }),
    ...mapGetters({
      totalPrice: "cart/totalPrice",
      totalItems: "cart/itemsCount"
    })
  },
  methods: {
    handleClickOnConfirmation() {
      this.$router.push("/confirmationviewformvalidation");
    },
    handleBtnRemoveItem(item) {
      this.$store.commit("cart/REMOVE_ITEM_STATE", item);
      this.$store.commit("cart/UPDATE_ESTIMATED_TIME_STATE", {});
      this.$emit('itemInCartRemoved', {});
    },
    handleBtnBackToMenu() {
      this.$router.push("/menu");
    },
    handleItemInCartQuantityChange() {
      console.log('item quantity updated!')
      this.$store.commit("cart/UPDATE_ESTIMATED_TIME_STATE", {});
      this.$emit('itemInCartQuantityUpdated', {});
    },

    getPrice(item) {
      return PriceCalculator.getProductPrice(item.itemPrice, item.addedPrice, item.discount);
    },

    handleBtnApplyCoupon() {
      let discountCode = DiscountCodes.findDiscountCode(this.couponCode);
      if (!discountCode) {
        this.couponError = true;
        this.couponMessage = "Ugyldig kupongkode";
        return;
      }
      this.$store.commit("cart/APPLY_DISCOUNT_CODE_STATE", discountCode);
      this.couponError = false;
      this.couponMessage = `Kupongkoden ${discountCode.code} er brukt (-${discountCode.percent}%)`;
    },

    handleBtnRemoveCoupon() {
      this.$store.commit("cart/CLEAR_DISCOUNT_CODE_STATE");
      this.couponCode = "";
      this.couponError = false;
      this.couponMessage = "";
    }
  }
};
</script>
 
<style lang="scss">
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;
.product-customize {
  width: 26% !important;
}
.customize-collapse {
  border-left: 1px solid #e3e3e3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31%;
}
.customize-collapse .ant-collapse {
  width: 211px;
}

.customize-collapse .ant-collapse-content > .ant-collapse-content-box {
  display: flex;
  flex-direction: column;
}
.customize-collapse
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  left: 8px;
}
.customize-collapse .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 6px 0;
  padding-left: 18px;
}
.customize-collapse .ant-collapse-header {
  text-align: center;
  font-family: "Bebas";
  font-weight: bold;
  letter-spacing: 1.5px;
  font-size: 13px;
}
.custom-title {
  color: #d40e0e;
  border: 2px solid;
  border-radius: 8px;
  font-size: 13px;
  font-weight: bold;
  margin-left: 10px;
  padding: 5px;
}

.total-price {
  border: 2px dashed #cecece;
  border-radius: 8px;
}

.cart-item:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
.cart-item {
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  border: 1px solid #e3e3e3;
  padding: 10px;
  margin: 10px 0 10px 0;
  background-color: whitesmoke;
  font-family: Bebas;
  transition: box-shadow 0.3s;
  @media (max-width: $tablet) {
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    width: 100%;
    margin: 16px 0;
  }

  & .product {
    width: 46%;
    margin-left: 10px;
    display: flex;
    align-items: center;
    & .product-name {
      margin-left: 10px;
      margin-bottom: 11px;
    }
    @media (max-width: $tablet) {
      margin-left: 0;
      width: 100%;
    }
  }
  & .product-remove {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .product-thumbnail {
    width: auto;
  }

  & .product-price {
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #e3e3e3;
    font-weight: 500;
    @media (max-width: $tablet) {
      border: none;
      justify-content: flex-end;
      width: 100%;
      position: relative;
      margin: 10px 0;
      &::before {
        content: "Price";
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  & .product-total {
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #e3e3e3;
    font-weight: bold;
    @media (max-width: $tablet) {
      border: none;
      justify-content: flex-end;
      width: 100%;
      position: relative;
      margin: 10px 0;
      &::before {
        content: "Total";
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  & .quantity-wrapper {
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #e3e3e3;
    @media (max-width: $tablet) {
      border: none;
      justify-content: flex-end;
      width: 100%;
      position: relative;
      margin: 10px 0;
      &::before {
        content: "Quantity";
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 5px;
      }
    }
  }
}

.table-header {
  display: flex;

  & div {
    width: 15%;
    text-align: center;
  }

  & .product-name {
    width: 24%;
    text-align: initial;
  }
  @media (max-width: $tablet) {
    display: none;
  }
}
.total-quantity {
  text-align: center;
  font-family: "Roboto";
  font-size: large;
}
.total-sum {
  font-size: 24px;
  font-weight: 800;
  font-family: Roboto;
  text-align: center;
  margin: 20px;
}
.cart-form {
  @media (max-width: $tablet) {
    margin: 20px 25px;
  }
}
.coupon-field input {
  padding: 19px;
  border: 1px solid black;
  border-radius: 5px;
  margin-right: 15px;
  font-size: 18px;

  &:focus {
    outline: none;
  }

  @media (max-width: $mobile) {
    padding: 5px;
    margin-right: 10px;
    width: 94px;
    font-size: 14px;
  }
}

.coupon-message {
  margin: 8px 0 0 0;
  font-family: Roboto;
  font-size: 14px;
  color: #1a7f37;
}
.coupon-message-error {
  color: #d44541;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 10px;
}

.blk-button {
  width: 180px;
  padding: 18px;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  font-family: Bebas;
  font-size: 18px;
  vertical-align: bottom;

  &.btn-pay {
    width: 100%;
    margin-top: 16px;
    @media (max-width: $mobile) {
      font-size: 20px;
      padding: 10px;
    }
  }

  @media (max-width: $mobile) {
    padding: 2px;
    width: 94px;
    font-size: 14px;
  }

  &:hover {
    background: #000000 !important;
    color: #ffffff !important;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
}
.cart-item {
  border-bottom: 1px solid #e1e1e1;
}

.cart-item div.product-thumbnail img {
  width: 150px;
  border-radius: 5%;
}

.cart-form-container {
  position: relative;
  margin-right: 6em;
  width: 1020px;
  font-family: bebas;
  letter-spacing: 1px;
  font-size: 18px;

  @media (max-width: $mobile) {
    width: auto;
  }
  @media (max-width: $tablet) {
    margin-right: 0;
  }

  @media (width: 1024px) {
    margin-right: 1em;
  }
  .cart-table {
    vertical-align: middle;
    width: 100%;
  }

  .cart-table th {
    padding: 10px 0;
    color: rgb(0, 0, 0);
    text-align: left;
  }

  .cart-table thead {
    border-bottom: 1px solid #e1e1e1;
  }
}
</style>
